const GETTERS = {
  cacheList: state => (payload) => {
    const result = state.cacheList.find(item => item.url === payload)
    return result ? result.data : null
  }
}

export default GETTERS



// WEBPACK FOOTER //
// ./src/store/modules/api/getters.js